import { render, staticRenderFns } from "./NewStoreRegist.vue?vue&type=template&id=489fa406&"
import script from "./NewStoreRegist.vue?vue&type=script&lang=js&"
export * from "./NewStoreRegist.vue?vue&type=script&lang=js&"
import style0 from "./NewStoreRegist.vue?vue&type=style&index=0&id=489fa406&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports